import { NavLink, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { NAV_ITEMS } from "@/config/nav";
import { cn } from "@/lib/utils";

export function Sidebar() {
  return (
    <aside
      className="w-[68px] shrink-0 h-full flex flex-col items-center bg-[#03080e]/95 backdrop-blur-xl border-r border-jarvis-cyan/12 py-3"
      data-testid="app-sidebar"
    >
      <Link to="/" data-testid="home-logo" title="Home — Command Center" className="relative w-9 h-9 flex items-center justify-center mb-4 shrink-0 group">
        <span className="absolute inset-0 rounded-full border border-jarvis-cyan/50 jv-pulse text-jarvis-cyan group-hover:border-jarvis-cyan" />
        <span className="w-2.5 h-2.5 rounded-full bg-jarvis-cyan shadow-[0_0_12px_rgba(0,240,255,0.9)] group-hover:shadow-[0_0_18px_rgba(0,240,255,1)]" />
      </Link>

      <nav className="flex-1 w-full overflow-y-auto flex flex-col items-center gap-1 px-1 [&::-webkit-scrollbar]:w-0">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.id}
              to={item.path}
              end={item.path === "/"}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                cn(
                  "group relative flex items-center justify-center w-11 h-11 rounded-lg transition-all duration-200 shrink-0",
                  isActive
                    ? "text-jarvis-cyan bg-jarvis-cyan/12"
                    : "text-slate-500 hover:text-jarvis-cyanBright hover:bg-white/[0.04]"
                )
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.span
                      layoutId="nav-active"
                      className="absolute left-0 top-2 bottom-2 w-[2px] rounded-full bg-jarvis-cyan shadow-[0_0_8px_rgba(0,240,255,0.9)]"
                    />
                  )}
                  <Icon className="w-[18px] h-[18px]" />
                  <span className="pointer-events-none absolute left-[52px] z-50 whitespace-nowrap rounded-md border border-jarvis-cyan/25 bg-[#0a0f1d] px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-200 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all">
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
